var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipseOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.75,
    fill: "white",
    stroke: "#D97706",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5C10 5.98891 9.70675 6.95561 9.15735 7.77785C8.60794 8.6001 7.82705 9.24096 6.91342 9.6194C5.99979 9.99784 4.99445 10.0969 4.02455 9.90393C3.05464 9.711 2.16373 9.2348 1.46447 8.53553C0.765204 7.83627 0.289 6.94536 0.0960736 5.97545C-0.0968525 5.00555 0.00216418 4.00021 0.380602 3.08658C0.759041 2.17295 1.3999 1.39206 2.22215 0.842652C3.04439 0.293245 4.01109 -1.17926e-08 5 0V5H10Z",
    fill: "#D97706"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseOrange);
export default __webpack_public_path__ + "static/media/ellipse-orange.33f9f487a20f1899baaab595ddfeb4a5.svg";
export { ForwardRef as ReactComponent };